import axios from 'axios'
import url from '@/url'

export const state = {
    admins:[]
}

export const actions = {
    createGlobalAdmin({commit},data) {
         return new Promise((resolve,reject)=> {
             axios.post(`${url()}/admin/create`,data)
                .then(response => {
                    if(response) {  
                        const admin = response.data.admin
                        commit('add_admin',admin)
                     }
                     resolve(response)
                }).catch(err => {
                    reject(err)
                })
         })
       },

    getAllAdmins({commit}){
       return new Promise((resolve, reject) => {
           axios.get(`${url()}/admins`)
            .then(response => {
                if(response.status === 200 ) {
                 commit('add_admins', response.data)   
                }
                resolve(response)
            }).catch(err => {
                console.log(err)
                reject(err)
            })
       })
    },
}

export const mutations = {
    add_admin(state,admin) {
        state.admins.push(admin)
    },
    add_admins(state,admins){
        state.admins = admins
    }
}
export const getters = {
    getAdmins: state => state.admins
}